module.exports = __webpack_public_path__ + "sn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/sn.svg
// module id = 1067
// module chunks = 0